import React from 'react';
import { useStyles } from './style';

interface ElipsisTextProps {
  children: React.ReactNode;
  labelWidth: number;
}
export default function EllipsisText(props: ElipsisTextProps) {
  const templateUploadStyles = useStyles();
  const { children, labelWidth } = props;

  return (
    <div style={{ maxWidth: labelWidth * 10 }} className={templateUploadStyles.chipLabel}>
      {children}
    </div>
  );
}
